export const orange = {
  900: '#783722',
  800: '#A74D2F',
  700: '#CA5D39',
  600: '#E66A42',
  500: '#FF7649',
  400: '#FF9978',
  300: '#FFB49B',
  200: '#FFCAB9',
  100: '#FFDED3',
  50: '#FFEFEA',
}
